<template>
  <div
    class="rounded-b relative h-48"
    :class="[co_teacher_tap_in ? 'h-56 flex justify-center w-96' : 'bg-gray-100']"
  >
    <div class="absolute left-0 bottom-0 top-0 right-0 z-10 w-full h-full">
      <div class="relative w-full h-full">
        <div class="flex flex-col space-y-2 h-full">
          <div :class="{'bg-gray-300 bg-opacity-50 backdrop-blur-lg': cameraOn, 'bg-gray-800 bg-opacity-50 backdrop-blur-lg': !cameraOn }" class="font-poppins text-xs py-0.5 text-white text-center">
            Teacher
          </div>
          <div class="flex justify-between items-center">
            <div v-if="speaking_teachers[coteacher.id]">
              <VolumeIndicator />
            </div>
          </div>
          <div @mouseover="isToSeeSettings = true" @mouseleave="isToSeeSettings = false" class="flex flex-grow px-2 h-full w-full">
            <div class="flex justify-center items-center w-full">
              <button
                v-if="video_audio_is_active && joinedAudioDiscussion && is_my_coteacher && cameraOn && isToSeeSettings"
                @click="openDeviceSettings()"
                class="flex justify-center text-center items-center bg-gray-500 bg-opacity-50 h-10 w-10 rounded-full"
              >
                <i class="fa-solid fa-gear text-white text-center text-lg" />
              </button>
            </div>
          </div>
          <div class="flex items-center justify-between pb-2 px-2">
            <div class="flex space-x-1.5 bg-gray-800 bg-opacity-50 rounded-full px-3 py-1.5 h-7 items-center">
              <div class="truncate text-white max-width-name text-xs">
                <span>{{ coteacher.name }}</span>
                <span class="text-pinky ml-0.5">(Me)</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="absolute" style="top: calc(50% - 40px); left: calc(50% - 40px)">
      <img
        :src="coteacher.avatar_url"
        class="rounded-full object-cover"
        :style="{
          width: co_teacher_tap_in ? '90px' : '70px',
          height: co_teacher_tap_in ? '90px' : '70px',
        }"
      />
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';
  import VolumeIndicator from './volumeIndicator.vue';

  export default {
    data() {
      return {
        video_audio_is_active: false,
        speaking_teachers: {},
        activeMoreOptions: false,
        micOn: false,
        cameraOn: true,
        isToSeeSettings: false,
      };
    },
    components: {
      VolumeIndicator,
    },
    props: {
      joinedAudioDiscussion: {
        type: Boolean,
        default: false,
      },
      coteacher: {
        type: Object,
        default() {
          return {};
        },
      },
      remoteUsers: {
        type: Array,
        default() {
          return [];
        },
      },
      rtc: {
        type: Object,
        default: {
          client: null,
          localAudioTrack: null,
          localVideoTrack: null,
        },
      },
      co_teacher_tap_in: {
        type: String,
        default: '',
      },
    },
    watch: {
      'getCurrentDiscussion.audio_discussion_is_enabled'() {
        this.video_audio_is_active =
          this.getCurrentDiscussion.audio_discussion_is_enabled;
      },
    },
    computed: {
      ...mapGetters([
        'getCurrentDiscussion',
        'getCourseDetail',
        'getProfile',
        'hasTeacherPermissionsInCourse',
      ]),
      co_teacher_joined_LD() {
        if (this.remoteUsers) {
          const coteacher = this.remoteUsers.find(
            (ru) => ru.uid === this.coteacher.id
          );
          return !!coteacher;
        }
        return false;
      },
      is_my_coteacher() {
        return this.coteacher.id === this.getProfile.id;
      },
    },
    methods: {
      toggleMic() {
        this.micOn = !this.micOn;
        if (this.micOn) {
          EventBus.$emit('unmuteAudio');
        } else {
          EventBus.$emit('muteAudio');
        }
      },
      toggleCam() {
        this.cameraOn = !this.cameraOn;
        if (this.cameraOn) {
          EventBus.$emit('videoOn');
        } else {
          EventBus.$emit('videoOff');
        }
      },
      openDeviceSettings() {
        EventBus.$emit('end-live-audio');
        this.cameraOn = true;
        this.micOn = false;
      },
    },
    mounted() {
      this.video_audio_is_active =
        this.getCurrentDiscussion.audio_discussion_is_enabled;

      EventBus.$on('end-participation-audio-live', () => {
        this.video_audio_is_active = false;
      });

      EventBus.$on('co_teachers_speaking', (teachers_list) => {
        this.speaking_teachers = teachers_list;
      });
    },
    beforeDestroy() {
      EventBus.$off('end-participation-audio-live');
      EventBus.$off('co_teachers_speaking');
    },
  };
</script>
<style lang="stylus" scoped>
  .participation-footer
    font-size: 10px
    color: white
</style>



// WEBPACK FOOTER //
// LDDiscussionCoTeacherCircle.vue?7def03bb